import React from 'react';

export const NotificationIcon = props => {
	const { text, fontSize, fill } = props;
	// Internet Explorer 6-11
	const isIE = /*@cc_on!@*/ false || !!document.documentMode;
	// Edge 20+
	const isEdge = !isIE && !!window.StyleMedia;
	const windows = isIE || isEdge;

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='27.997'
			height='21.808'
			viewBox='0 0 27.997 21.808'
		>
			<path
				id='prefix__Notification_Icon_Top_-_Billing_2560'
				d='M55.043 1117.982l-13.993 10.9v.008l13.993 10.9h.006l13.993-10.9v-.008l-13.993-10.9'
				data-name='Notification Icon Top - Billing 2560'
				transform='translate(-41.048 -1117.982)'
				fill={fill}
			/>
			<g>
				<text
					fontFamily="'Bourgeois-BoldCondensed'"
					fill='white'
					x='50%'
					y={windows ? '75%' : '55%'}
					fontSize={fontSize}
					dominantBaseline='middle'
					textAnchor='middle'
				>
					{text}
				</text>
			</g>
		</svg>
	);
};
